import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_video"}/>
}
